// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Curry from "melange.js/curry.js";
import * as JsxRuntime from "react/jsx-runtime";

function make(errors) {
  return function (field) {
    return function (children) {
      const errorText = Belt__Belt_List.getBy(errors, (function (error) {
              return error.field === field;
            }));
      return JsxRuntime.jsxs("div", {
                  children: [
                    children,
                    errorText !== undefined ? JsxRuntime.jsx("span", {
                            children: errorText.description,
                            className: "mt-2 text-sm text-red-600"
                          }) : null
                  ]
                });
    };
  };
}

function GrpcFieldErrorWrapper(Props) {
  return Curry._1(make(Props.errors)(Props.field), Props.children);
}

const make$1 = GrpcFieldErrorWrapper;

export {
  make$1 as make,
}
/* react/jsx-runtime Not a pure module */
